import { render, staticRenderFns } from "./AgePension.vue?vue&type=template&id=43ad647d&"
import script from "./AgePension.vue?vue&type=script&lang=js&"
export * from "./AgePension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports